import { pathOr } from 'ramda';
import { useSportsbookStore } from '../../store';

export const selectCategoryById = (categoryId, serviceId) =>
  pathOr({}, ['categories', serviceId, 'data', categoryId]);

export const useCategory = (categoryId, serviceId) =>
  useSportsbookStore(selectCategoryById(categoryId, serviceId));
